//example to JSON Date "2020-08-23T23:22:43.176Z" return "23/08/2020"
export default (currentDate: string | number): string => {
  if (!currentDate) {
    return '';
  }
  return new Date(currentDate).toJSON()?.split('T')[0];
};
